export enum SubmittedOrderStatus {
  Open = 0,
  PreparingDelivery = 1,
}
